"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.StyledAvatarGroupCount = exports.StyledAvatarGroup = void 0;

var _stitches = require("../theme/stitches.config");

var _avatar = _interopRequireDefault(require("./avatar.styles"));

const StyledAvatarGroupCount = (0, _stitches.styled)('span', {
  fontSize: '$xs',
  display: 'inline-flex',
  alignItems: 'center',
  marginLeft: '$3',
  color: '$text'
});
exports.StyledAvatarGroupCount = StyledAvatarGroupCount;
const StyledAvatarGroup = (0, _stitches.styled)('div', {
  dflex: 'center',
  height: 'auto',
  width: 'max-content',
  '@motion': {
    transition: 'none'
  },
  [`& ${_avatar.default}`]: {
    marginLeft: '-$space$5',
    transition: '$default',
    '.only-text-avatar': {
      boxShadow: '$xs'
    }
  },
  '.only-text-avatar': {
    boxShadow: '$xs'
  },
  variants: {
    animated: {
      true: {
        [`& ${_avatar.default}:hover`]: {
          transform: 'translate(-$space$5)'
        }
      }
    }
  },
  defaultVariants: {
    animated: true
  }
});
exports.StyledAvatarGroup = StyledAvatarGroup;
var _default = StyledAvatarGroup;
exports.default = _default;